import styled from '@emotion/styled';
import { createTrackerShareLink } from '@racemap/utilities/functions/createTrackerShareLink';
import React, { type FC } from 'react';
import { ShareModal } from 'src/components/BasicComponents/ShareModal/ShareModal';
import { useTrackersForAction } from '../../../lib/customHooks';

export const ShareTrackerButton: FC = () => {
  const trackersToUse = useTrackersForAction();
  const [isShareModalOpen, setIsShareModalOpen] = React.useState(false);
  const trackerIds = trackersToUse ? trackersToUse.map((tracker) => tracker.id.toHexString()) : [];

  return (
    <>
      <Container onClick={() => setIsShareModalOpen(true)}>
        <div>Share tracker</div>
      </Container>
      <ShareModal
        link={createTrackerShareLink(trackerIds)}
        description="Hey, I wanted to share these trackers with you! Check them out using the link below."
        isOpen={isShareModalOpen}
        onCancel={() => setIsShareModalOpen(false)}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
